// Shared rolling-window upload-speed estimator, used by both drop pads: the
// client portal (SharePortalPage) and the operator-side FlatFileSessionPanel.

export interface SpeedSample {
  ts: number;
  bytes: number;
}

/** Bytes/sec over a rolling ~1.5s window of (timestamp, cumulative-bytes) samples. */
export function computeSpeed(samples: SpeedSample[], bytesUploaded: number, now: number): number {
  const windowMs = 1500;
  const recent = samples.filter((s) => now - s.ts <= windowMs);
  if (recent.length < 2) return 0;
  const oldest = recent[0]!;
  const newest = recent[recent.length - 1]!;
  const elapsed = (newest.ts - oldest.ts) / 1000;
  if (elapsed <= 0) return 0;
  const delta = bytesUploaded - oldest.bytes;
  return Math.max(0, delta / elapsed);
}
